/**
 * 406 (#1369): shown in place of Pay Now, Book and CARii's penalty QR while the banks' Friday downtime pauses
 * payments, and at the top of the booking form. The same sentence the server's refusal carries
 * (`shared/paymentPause.ts`).
 */
export const PAYMENT_PAUSE_SENTENCE =
  "Payments are paused for the banks' Friday maintenance. Please try again after 1:30 AM.";

export function PaymentPauseNotice({
  className = 'mt-6',
  testId = 'payment-pause-notice',
}: {
  className?: string;
  testId?: string;
}) {
  return (
    // <output> is the native status region: assistive technology reads the notice when it appears.
    <output data-testid={testId} className={`${className} block text-sm text-yellow-400`}>
      {PAYMENT_PAUSE_SENTENCE}
    </output>
  );
}
